import { css } from 'lit'

export const EtaChangeReviewWrapperStyles = css`
    .eta-change-review {
        padding-top: 8px;
        padding-left: 24px;
        padding-right: 24px;
        padding-bottom: 8px;
        font-family: MaerskText;
    }

    .eta-change-review-content{
        border: 2px solid rgb(20 20 20 / 16%);
        border-radius: 4px;
        padding:8px;
    }

    .heading {
        display: flex;
        justify-content: space-between;
        align-items: start;
    }

    .title-wrapper {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .title {
        font-size: 22px;
        display: flex;
        align-items: center;
    }

    .description {
        font-size: 14px;
        margin: 0;
        color: #666;
    }

    .heading-status-contents {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .last-updated {
        font-size: 12px;
        display: flex;
    }

    .color {
        color: green;
        padding-left: 4px;
    }

    .delay {
        color: red;
    }

    .back-button {
        background: none;
        border: none;
        cursor: pointer;
        padding: 0;
    }

    .charts-block {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .chart-card {
        height: 29rem;
    }

    .details-card {
        display: flex;
        gap: 16px;
        justify-content: space-between;
    }

    .eta-table,
    .eta-comparison table {
        border-collapse: collapse;
        font-size: 13px;
        font-family: MaerskText;
    }

    .eta-table th,
    .eta-table td,
    .eta-comparison th,
    .eta-comparison td {
        padding: 8px 10px;
        border: 1px solid #ddd;
    }

    th {
        text-align: left;
        font-size: 14px;
    }

    .eta-comparison {
        min-width: 350px;
        margin-bottom: 0.5rem;
    }

    .eta-comparison .highlight {
        font-weight: bold;
        color: #003366;
    }

    .eta-comparison th span {
        font-size: 12px;
        font-weight: normal;
        color: #888;
    }

    .action-section {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }

    .instructions {
        font-size: 14px;
        color: #333;
    }

    .actions {
        display: flex;
        gap: 30px;
        width: 100%;
    }

    .eta-actions-section {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .warning {
        color: red;
        font-size: 14px;
        display: grid
    }

    .decline {
        margin-left: 5px;
        background-color: rgb(252, 221, 223);
        font-size: 15px;
        border-radius: 14px;
        text-align: center;
        padding: 2px 11px;
    }

    .requested {
        margin-left: 5px;
        background-color: #DCF6D9;
        font-size: 15px;
        border-radius: 14px;
        text-align: center;
        padding: 2px 11px;
    }

    .decline-icon {
        display: inline-flex;
        align-items: center;
        margin-right: 15px;
        justify-content: left;
    }

    .code {
        color: #666;
        margin: 0;
        font-size: 11px;
        padding-bottom: 8px;
    }
    
    .column {
        color: #666;
    }

    .calculate{
        border: none;
        width: 10.5rem;
    }

    input[type="datetime-local"]{
        font-family: var(--component-paragraph-ff, serif);
        font-size: 13px;
        box-sizing: border-box;
        width: 10.5rem;
        border: none;
        outline: none;
        color: var(--neutrals-grey-02);
        background-color: unset;
    }

    .eta-comparison .edit-btn:hover {
        color: #003366;
    }

    .eta-comparison .edit-btn {
        background: none;
        border: none;
        cursor: pointer;
        padding: 0;
        line-height: 1;
        align-items: center;
        width: 0.85rem;
        margin-left: 10px;
    }

    .validation-text {
        color: var(--feedback-danger, red);
        display: block;
        font-size: 12px;
        margin-bottom: 8px;
    }
`
export const EtaChangeChartStyles = css`

:host {
      display: block;
      width: 100%;
      height: 260px;
    }

    .custom-legend {
    font-family: 'MaerskText';
    font-size: 10px;
  }

  .legend-lines,
  .legend-icons {
    display: flex;
    gap: 16px;
    align-items: center;
    margin-bottom: 4px;
    justify-content: flex-end;
  }

  .legend-item {
    display: flex;
    align-items: center;
    gap: 4px;
    background-color: white;
    border: none;
    font-size: 11px;
  }

  .line {
    width: 24px;
    height: 3px;
  }

  .actual {
    background-color: var(--performance-viewer-actual-color); 
  }

  .current {
    background-color: var(--current-route); 
  }

  .new {
    background-color: var(--requested-route);
  }

  .icon {
    width: 10px;
    height: 10px;
  }

  .new-pilot-point {
    color: #FFD029; 
  }

  .current-pilot-point {
    color: #9C27B0;
  }
    .chart {
                flex-direction: row;
                font-family: 'MaerskText';
            }

            .chart[shown] {
                display: flex;
            }
            voy-timeseries-chart {
                pointer-events: auto;
            }
  .heading{
    display: flex;
    justify-content: space-between;
  }

  .title{
    font-size: 12px;
    margin-top: 10px;
  }

`
